import './_input.hints.scss';
import './_input.hints.dark-mode.scss';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const InputHints = forwardRef(({ hints, children, deleteService, dispatchDelete }, ref) => {
  const node = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const [hintsList, setHintsList] = useState(hints || [])

  const outSideClickOutside = (e) => {
    if (ref.current && ref.current.contains(e.target) && !isOpen) {
      setOpen(true)
      return;
    }
    if (node.current && node.current.contains(e.target)) {
      return false;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (document.activeElement === ref.current) {
      setOpen(true)
    }

    document.addEventListener('mousedown', outSideClickOutside, false);

    return () => {
      document.removeEventListener('mousedown', outSideClickOutside, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onRequestDelete = async (id) => {
    try {
      await deleteService(id);

      if (dispatchDelete) {
        dispatchDelete(id);
      }

      // eslint-disable-next-line no-empty
    } catch (error) {}
  }

  const onDelete = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    setHintsList(hintsList.filter((hint) => hint.id !== id))

    if (deleteService) {
      onRequestDelete(id)
    }
  }

  const onSelectHint = (value) => {
    if (ref?.current) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        ref.current.nodeName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype,
        'value',
      ).set;
      nativeInputValueSetter.call(ref.current, value);
      const event = new Event('input', { bubbles: true });
      ref.current.dispatchEvent(event);
    }
    setOpen(false);
  }

  return (
    <div
      ref={node}
      className="input-hints"
    >
      {children}
      {hintsList.length
        ? (
          <div
            className="input-hints__list"
            style={{ display: isOpen ? 'block' : 'none' }}
          >
            {hintsList.map((hint, index) => (
              <div
                onClick={() => onSelectHint(hint.comment)}
                className="input-hints__list-item"
                key={`hint-${index}`}
              >
                <div className="input-hints__list-item-left">
                  <div
                    className="input-hints__list-item-name"
                  >
                    {hint.comment}
                  </div>
                </div>
                <div className="input-hints__list-item-close">
                  <button onClick={(e) => onDelete(e, hint.id)}>
                    <i className="far fa-times" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : null}
    </div>
  );
});

InputHints.propTypes = {
  hints: PropTypes.array,
  children: PropTypes.object,
  deleteService: PropTypes.func,
  dispatchDelete: PropTypes.func,
};

export default InputHints;
